import httpRepo from '../httpRepo';
import { agentEndpoints } from '../apiConfig';

export const downloadPDFReport = async (data) => {
    return await httpRepo.postBlob(agentEndpoints.downloadPDFReport, data, {isPublicAPI: true});
};
